<template>
  <div>
    <v-card elevation="0">
      <v-card-title>
        <span class="headline pt-6 pl-6">For Dispatch</span>
        <v-spacer></v-spacer>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              class="mx-2"
              fab
              small
              color="primary"
              depressed
              :disabled="selected.length==0"
              v-on="on"
              @click="addAllSelectedItems()"
            >
              <v-icon dark>
                mdi-plus
              </v-icon>
            </v-btn>
          </template>
          <span>Add Selected Item(s)</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              class="mx-2"
              fab
              small
              depressed
              color="grey lighten-2"
              v-on="on"
              @click="forDeliveryDialog.show = false"
            >
              <v-icon dark>
                mdi-close
              </v-icon>
            </v-btn>
          </template>
          <span>Close</span>
        </v-tooltip>
      </v-card-title>

      <v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>

        </v-card-actions>
        <v-data-table
          v-model="selected"
          show-select
          class="pa-6"
          :headers="headers"
          :items="items"
          :loading="loading"
          :items-per-page="1000"
          loading-text="Loading For Dispatches..."
          item-key="id"
          no-data-text="No For Dispatches Found"
          hide-default-footer
          ref="table">

          <template v-slot:[`item.is_active`]="{ item }">
            <v-chip class="ma-2" v-if="!item.is_active" small>No</v-chip>
            <v-chip class="ma-2" color="primary" v-if="item.is_active" small>Yes</v-chip>
          </template>

        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
  export default {
    name: 'ForDeliveryDialogPage',
    props: ['forDeliveryDialog'],
    data: () => ({
      loading: false,
      selected: [],
      items: [],
      headers: [
        {
          text: 'Shipping Mark',
          align: 'start',
          value: 'shipping_mark',
          sortable: false,
          width: 200
        },
        {
          text: 'Description',
          align: 'start',
          value: 'item_description',
          sortable: false,
        },
        {
          text: 'Qty',
          align: 'start',
          value: 'qty',
          sortable: false,
        }
      ]
    }),
    watch: {
      forDeliveryDialog: {
        handler () {
          this.getItems()
        },
        deep: true
      },
    },
    methods: {
      addAllSelectedItems () {
        this.forDeliveryDialog.show = false
        this.$emit('selectItem', this.selected)
      },
      selectItem (item) {
        this.forDeliveryDialog.show = false
        this.$emit('selectItem', item)
      },
      getItems () {
        if (this.loading) {
          return false
        }

        let params = []

        if (this.forDeliveryDialog.selected_items.length > 0){
          params.push('no_show_selected_item='+this.forDeliveryDialog.selected_items)
        }

        let queryStr = ''
        params.forEach(param => {
          queryStr+= param
        })

        if(this.forDeliveryDialog.client_id == ''){
          return false
        }

        this.selected = []

        this.loading = true
        let self = this
        this.$http.plain.get('operations/for-deliveries/'+this.forDeliveryDialog.client_id+'?' + queryStr)
          .then(response => {
            this.items = response.data
          })
          .catch(error => {
            console.log(error);
          })
          .then(function () {
            self.loading = false
          })
        }
    },
    mounted() {
      this.getItems()
    },
    components: {
    }
  }
</script>
